"use client"

import React from "react"
import CheckoutHeader from "../CheckoutHeader"
import { usePathname } from "next/navigation"

interface HeaderWrapperProps {
    children: React.ReactNode
}

export default function HeaderWrapper({ children }: HeaderWrapperProps) {
    const params = usePathname()

    //   If the last part of the URL is "checkout", "information", "shipping" or "payment",
    //   render the CheckoutHeader component, otherwise render the children. (Default Header component)

    const CheckoutPage =
        params.split("/").pop() === "checkout" ||
        params.split("/").pop() === "information" ||
        params.split("/").pop() === "shipping" ||
        params.split("/").pop() === "payment"

    if (CheckoutPage) {
        return <CheckoutHeader />
    } else {
        return <div>{children}</div>
    }
}
